var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Border",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 0.816406,
    y: 0.342773,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#1565D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Email"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7494 28.1251V43.176C49.7494 46.2688 47.2422 48.776 44.1494 48.776H21.7494C18.6566 48.776 16.1494 46.2688 16.1494 43.176V28.1251C16.1494 27.3439 16.5325 26.6124 17.1749 26.1653L21.2646 23.3192C21.6272 23.0668 22.1258 23.1562 22.3782 23.5189C22.6306 23.8815 22.5412 24.3801 22.1785 24.6325L18.0888 27.4786C17.8792 27.6245 17.7535 27.8604 17.7495 28.1127C17.9997 28.0243 18.2689 27.9762 18.5494 27.9762C18.9774 27.9762 19.3976 28.0906 19.7665 28.3077L32.9494 36.0644L46.1323 28.3077C46.7677 27.9338 47.5046 27.8858 48.1493 28.1133C48.1455 27.8608 48.0198 27.6246 47.81 27.4786L43.8374 24.714C43.4747 24.4616 43.3853 23.963 43.6377 23.6004C43.8901 23.2377 44.3887 23.1483 44.7513 23.4007L48.7239 26.1653C49.3663 26.6124 49.7494 27.3439 49.7494 28.1251Z",
    fill: "#DFAD17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1494 27.6758V19.6758C21.1494 17.4666 22.9403 15.6758 25.1494 15.6758H41.1494C43.3586 15.6758 45.1494 17.4666 45.1494 19.6758V27.6758L33.1494 34.8758L21.1494 27.6758ZM28.3494 23.6758H37.9494C38.3912 23.6758 38.7494 23.3176 38.7494 22.8758C38.7494 22.434 38.3912 22.0758 37.9494 22.0758H28.3494C27.9076 22.0758 27.5494 22.434 27.5494 22.8758C27.5494 23.3176 27.9076 23.6758 28.3494 23.6758ZM38.7494 27.6758C38.7494 28.1176 38.3912 28.4758 37.9494 28.4758H28.3494C27.9076 28.4758 27.5494 28.1176 27.5494 27.6758C27.5494 27.234 27.9076 26.8758 28.3494 26.8758H37.9494C38.3912 26.8758 38.7494 27.234 38.7494 27.6758Z",
    fill: "#B8D0F3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.e73538624b3f98fda0496cd9891a1451.svg";
export { ForwardRef as ReactComponent };